import {Subscription} from '@/store/Messaging.store';

import {EventReceivedCallback} from '@/services/Events.service';

export class EventSubscriptions {
  constructor(
    public Callbacks: Map<number, EventReceivedCallback>,
    public MessagingSubscription: Subscription,
  ) {
  }
}
